
import Repository from './Repository';
import TokenService from '../helper/token';

export default {
  async getProductAttributes(pcmResource, params) {
    const response = await Repository.get(`${pcmResource}/api/product-attributes`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async advanceSearchForComboV2(pcmResource, params) {
    const response = await Repository.get(`${pcmResource}/api/skus/search-sku-v2`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response
  },
  async getClassType(pcmResource,params) {
    const response = await Repository.get(`${pcmResource}/api/skus/class-type-and-lessons-group`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getCurriculumAttributes(url, params) {
    const response = await Repository.get(`${url}/fg/list-data?obj=program&filters[$eq__status]=1&attrs[]=id&attrs[]=title&attrs[]=subject_id`, {
      params,
      headers: {
        Authorization: `Bearer 3900721fde08f3f01eb450697e0a681b1a52264de0de3ed10ac0001016100601`
      },
    })
    return response
  },
  async getChosePackagesTransferApi(url,params) {
    const response = await Repository.get(`${url}/product-fee-transfer/get-chose-packages-data`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async createCrossFeeTransferProductApi(url,data) {
    const response = await Repository.post(`${url}/product-fee-transfer/create-cross-fee-transfer-product`, data,{
      headers: TokenService.getHeader(),
    })
    return response
  },
  async changeStatusTransferApi(url,recordId, data) {
    const response = await Repository.patch(`${url}/product-fee-transfer/change-cross-fee-transfer-product-status/${recordId}`, data, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getPreviewApi(url,id, params) {
    const response = await Repository.get(`${url}/product-fee-transfer/get-popup-confirm-transfer-info/${id}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async changeCrossFeeCustomerApi(url,data) {
    const response = await Repository.post(`${url}/product-fee-transfer/change-cross-fee-transfer-product-customer`, data, {
      headers: TokenService.getHeader(),
    })
    return response
  },
};
